import React from "react";
import { useDrop } from "react-dnd";

import { ReactComponent as CancelIcon } from "../../../../assets/icon/cancel.svg";
import { IFile, IStudent } from "../../../../state";
import Avatar from "../../../../molecules/Avatar";
import { DnDItemTypes } from "../../../../pages/manager/UploadStudentRealPhotos/types";

import styles from "./StudentListItem.module.scss";

export type StudentWithUploadedFile = IStudent & { uploadedFile?: IFile };

type Props = {
  student: StudentWithUploadedFile;
  onDrop: (params: {
    photo_id: number;
    student: StudentWithUploadedFile;
  }) => void;
  onCancelDrop: (student: StudentWithUploadedFile) => void;
  onDeletePhoto: (student: StudentWithUploadedFile) => void;
};

export default function StudentListItem({
  student,
  onDrop,
  onCancelDrop,
  onDeletePhoto,
}: Props) {
  const handleDrop = (item: any, _monitor: any) => {
    onDrop({ photo_id: item.value, student });
  };

  const [{ isOver }, drop] = useDrop({
    accept: DnDItemTypes.PHOTO,
    drop: handleDrop,
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div className={styles.container}>
      <div className="row align-items-center justify-content-between">
        <div className="col-6">
          {student.last_name}
          {"　"}
          {student.first_name}
        </div>
        <div className="col-6" style={{ maxWidth: "156px" }}>
          <div
            ref={drop}
            className={isOver ? "dropping" : ""}
            style={{
              position: "relative",
              maxWidth: "120px",
              maxHeight: "120px",
            }}
          >
            <div
              className="card-img-overlay rounded-circle"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                visibility: isOver ? "visible" : "hidden",
                zIndex: 10,
              }}
            />
            {student.uploadedFile ? (
              <div className={styles.uploadedFileArea}>
                <Avatar
                  size={120}
                  src={student.uploadedFile.url}
                  alt={student.uploadedFile.name}
                />
                <CancelIcon
                  color="#e35d6a"
                  className={styles.cancelIcon}
                  onClick={_e => onCancelDrop(student)}
                />
              </div>
            ) : student.real_photo ? (
              <div className={styles.uploadedFileArea}>
                <Avatar
                  size={120}
                  src={student.real_photo.url}
                  alt={student.real_photo.name}
                />
                <CancelIcon
                  color="#e35d6a"
                  className={styles.cancelIcon}
                  onClick={_e => onDeletePhoto(student)}
                />
              </div>
            ) : (
              <div className={styles.dropArea}>
                ここに{"\n"}ドラッグ&{"\n"}ドロップ
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
